import React from 'react';
import withRoot from "../../../withRoot";
import Header from "../../../adviser/Dashboard/Header";
import Title from "../../../customer/ProductsCustomer/Title";
import ByPolko from "../../../customer/ByPolko";
import CheckoutConfirmar from "./Checkout";

function ConfirmarPage(props) {

    return (
        <React.Fragment>
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    width: "100%",
                    height:"100%",
                    backgroundColor: "#F5F6F9",
                }}
            >
                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        width: "100%",
                    }}
                >
                    <Header role={"Asesor"}/>
                </div>

                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        width: "100%",
                        marginBottom: "50px"
                    }}
                >
                    <Title
                        title={"SEGUROS"}
                        subtitle={"¡Complete el formulario para confirmar esta emisión!"}
                    />
                </div>

                <div style={{
                    marginBottom: "56px"
                }}>
                     <CheckoutConfirmar
                            rowData={props.location.state.data}/>
                </div>


                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        width: "100%",
                        marginBottom: "80px"
                    }}
                >
                    <ByPolko fontSize={25}/>
                </div>
            </div>
        </React.Fragment>
    )
}

export default (withRoot(ConfirmarPage));

